import { Tag as ChakraTag } from '@chakra-ui/react';
import React from 'react';

export interface TagProps extends ChakraTag.RootProps {
  startElement?: React.ReactNode;
  endElement?: React.ReactNode;
  onClose?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  closable?: boolean;
  labelProps?: ChakraTag.LabelProps;
}

export const Tag = React.forwardRef<HTMLSpanElement, TagProps>(function Tag(props, ref) {
  const {
    startElement,
    endElement,
    onClose,
    closable = !!onClose,
    children,
    labelProps,
    ...rest
  } = props;

  return (
    <ChakraTag.Root ref={ref} alignContent='center' {...rest}>
      {startElement && <ChakraTag.StartElement>{startElement}</ChakraTag.StartElement>}
      <ChakraTag.Label {...labelProps}>{children}</ChakraTag.Label>
      {endElement && <ChakraTag.EndElement>{endElement}</ChakraTag.EndElement>}
      {closable && (
        <ChakraTag.EndElement>
          <ChakraTag.CloseTrigger onMouseDown={onClose} />
        </ChakraTag.EndElement>
      )}
    </ChakraTag.Root>
  );
});
